<div>
    <!-- <div style="height: 30px;text-align: center;background-color: #1b2464;"> -->
    <div class="confirm_dialog_header">
        <h5 class="h5_class global-h5">Confirmation</h5>
    </div>

    <div style="padding: 4%; height: auto; display: flex; align-items: center; overflow: auto;">
        <!--  <div *ngIf="dialogData.message">
        <h4 class="global-h4">{{ dialogData.heading }}</h4>
        <p class="global-p" style="padding-left: 24px;">{{ dialogData.message }}</p>
    </div>
    <div *ngIf="!dialogData.message">
        <h4 class="global-h4">{{ dialogData.heading }}</h4>
    </div> -->
        <div>
            <h4 class="h4_class global-h4">{{ dialogData.heading }}</h4>
        </div>
    </div>
    <div class="options">
        <button mat-stroked-button color="primary" [mat-dialog-close]="true" class="okay global-button confirm_right_side_button"
             style="float: right; width: 110px !important;"> {{rightBtn}} </button>
        <button class="global-button confirm_left_side_button" mat-stroked-button color="primary" [mat-dialog-close]="false"
            style="float: right; width: 91px !important;">
            {{leftBtn}} </button>
        <button class="global-button" *ngIf="showCancel" mat-stroked-button color="primary" [mat-dialog-close]
            style="width: 91px !important; margin-left: 12px;"> Cancel </button>
    </div>
</div>






<!-- <div class="messages">
    <div *ngIf="dialogData.message">
        <h4 class="global-h4">{{ dialogData.heading }}</h4>
        <p class="global-p" style="padding-left: 24px;">{{ dialogData.message }}</p>
    </div>
    <div *ngIf="!dialogData.message">
        <h4 class="global-h4">{{ dialogData.heading }}</h4>
    </div>
</div>
<div class="options">
    <button mat-stroked-button color="primary" [mat-dialog-close]="true" class="okay global-button"
        style="float: right; width: 110px !important;"> {{rightBtn}} </button>
    <button class="global-button" mat-stroked-button color="primary" [mat-dialog-close]="false" style="float: right; width: 91px !important;">
        {{leftBtn}} </button>
    <button class="global-button" *ngIf="showCancel" mat-stroked-button color="primary" [mat-dialog-close]
        style="width: 91px !important; margin-left: 12px;"> Cancel </button>
</div> -->